export default __webpack_public_path__ + "assets/images/Payment_08.937c54.webp";